import React__default, { forwardRef } from 'react';
import { StyledRadio } from './styles.js';
import { RadioGroupContext } from '../RadioGroup/RadioGroup.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// @TODO: form validation status
/**
 * Accessible, ecosystem-agnostic radio button that can be styled as needed. A single radio button within the group can be selected at a time.
 */
const Radio = /*#__PURE__*/forwardRef(({
  value,
  name: nameProp,
  disabled: disabledProp,
  onChange,
  checked,
  required,
  sx: sxProp,
  ...props
}, forwardedRef) => {
  const innerRef = React__default.useRef(null);
  const radioGroupContext = React__default.useContext(RadioGroupContext);
  const handleOnChange = e => {
    if (radioGroupContext !== null && radioGroupContext !== void 0 && radioGroupContext.onChange) radioGroupContext.onChange(e);
    return onChange && onChange(e);
  };
  const name = nameProp || (radioGroupContext === null || radioGroupContext === void 0 ? void 0 : radioGroupContext.name);
  const disabled = disabledProp || (radioGroupContext === null || radioGroupContext === void 0 ? void 0 : radioGroupContext.disabled);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  if (!name) {
    // eslint-disable-next-line no-console
    console.warn('A radio input must have a `name` attribute. Pass `name` as a prop directly to each Radio, or nest them in a `RadioGroup` component with a `name` prop');
  }
  return /*#__PURE__*/React__default.createElement(StyledRadio, _extends({
    type: "radio",
    value: value,
    name: name,
    ref: innerRef,
    disabled: disabled,
    checked: checked,
    required: required,
    "aria-checked": checked ? 'true' : 'false',
    onChange: handleOnChange,
    sx: sxProp
  }, props));
});
Radio.displayName = 'Radio';
var Radio$1 = Radio;

export { Radio$1 as default };
